// extracted by mini-css-extract-plugin
export default {"popup":"popup-LLJd_","title":"title-X3zXd","subTitle":"subTitle-vMK3W","footer":"footer-FHzmB"};